module.exports = __webpack_public_path__ + "img/partner28.7ee9360c.png";